module.exports = __webpack_public_path__ + "img/Visa.0d1fbbc4.svg";